import type { AdminServiceDetailQueryKey, BuildAdminServiceDetailQueryKeyParams } from '../types';

const buildAdminServiceDetailQueryKey = ({
    serviceId,
}: BuildAdminServiceDetailQueryKeyParams): AdminServiceDetailQueryKey => [
    'admin-services',
    serviceId,
];

export default buildAdminServiceDetailQueryKey;
